import React from "react";
import Map from "../components/Map/Map";
import { Navbar } from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import CurrentProjects from "../components/CurrentProjects/CurrentProjects";
import FormHelp from "../components/FormHelp/FormHelp";
import Requisites from "../components/Requisites";

export const Projects = () => {
  
  return (
    <div >
      <FormHelp />
      <Requisites />
      <Navbar color="menu-wrap" />
      <div className="container" id="homepage">
        <Map />
        <CurrentProjects />
      </div>
      <Footer />
    </div>
  );
};
